<script setup lang="ts">

import { computed, defineProps } from 'vue'
import type { PropType } from 'vue';
import { useGameStore } from '@/stores/gameStore.ts'
import type OreConversion from '@/types/OreConversion.ts'
import ConveyorTRTCBCBL from '@/components/Sections/Resources/Elements/Conveyor/ConveyorTRTCBCBL.vue'
import ConveyorTLTCBCBR from '@/components/Sections/Resources/Elements/Conveyor/ConveyorTLTCBCBR.vue'
import { CDN } from '@/models/cdn.ts'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const gameStore = useGameStore()

const planetNameMap: Record<number, string> = {
  1: 'map.planets.lava',
  2: 'map.planets.desert',
  3: 'map.planets.temperate',
  4: 'map.planets.oceanic',
  5: 'map.planets.gas',
  6: 'map.planets.ice',
  7: 'map.planets.ferion',
  8: 'map.planets.ringworld'
}

const props = defineProps({
  planetType: {
    type: Number,
    required: true
  },
  oreLeft: {
    type: Number,
    required: true
  },
  oreRight: {
    type: Number,
    required: true
  },
  conversionLeft: {
    type: Object as PropType<OreConversion>,
    required: true
  },
  conversionRight: {
    type: Object as PropType<OreConversion>,
    required: true
  },
  top: {
    type: Number,
    required: true
  },
  left: {
    type: Number,
    required: true
  },
  debug: {
    type: Boolean,
    required: false,
    default: false
  }
})


const planetTypeName = computed(() => {
  const key = planetNameMap[props.planetType]
  return key ? t(key) : t('map.planets.unknown')
})

const planetTypeColor = computed(() => {
  if(props.planetType === gameStore.player?.homeWorldPlanetType) {
    return 'text-green-500'
  } else if (props.planetType === gameStore.player?.homeWorldOppositePlanetType) {
    return 'text-red-500'
  } else {
    return 'text-white'
  }
})


</script>

<template>
  <div :class="{
          'absolute rounded':true,
          'border':debug
        }"
       :style="'top:' + props.top + 'rem;left:' + props.left + 'rem;width:15rem;height:15rem;'"
  >

    <!-- Planet -->
    <div :class="{
      'absolute text-center':true,
      [planetTypeColor]:true
    }" style="width:15rem;z-index:15">{{ planetTypeName }}</div>
    <!-- Black circle background for ringworld with fade edge -->
    <div v-if="props.planetType === 8" 
         class="absolute rounded-full" 
         style="top:1.5rem;left:4.5rem;width:6rem;height:6rem;z-index:14;background:radial-gradient(circle, #0f172a 85%, transparent 100%)"></div>
    <img :class="{
          'absolute mb-1':true,
          'opacity-50':debug
        }" :style="props.planetType === 8 ? 'top:2.1rem;left:5.1rem;width:4.8rem;z-index:15' : 'top:1.5rem;left:4.5rem;width:6rem;z-index:15'" :src="CDN.planet(128,3,props.planetType)">


    <ConveyorTRTCBCBL
      :object-image="CDN.icon('ore' + props.oreLeft)"
      :conversion="props.conversionLeft"
      :width="9"
      :height="10.5"
      :top="4"
      :left="-2"
      :debug="debug"
      :centerX="5"
    />


    <ConveyorTLTCBCBR
      :object-image="CDN.icon('ore' + props.oreRight)"
      :conversion="props.conversionRight"
      :width="9"
      :height="10.5"
      :top="4"
      :left="8"
      :debug="debug"
      :centerX="3"
    />

<!--    <ResourceProcessedAmount :left="10" :top="1.9" textAlign="right" :conversion="props.conversionRight"/>-->
  </div>
</template>

<style scoped lang="scss">

</style> 